import { gql } from '@apollo/client'

export const ProductDescriptionFragment = gql`
  fragment ProductDescription on ProductDescription {
    description
    image
    title
    url
    value
  }
`

export const OnBoardingFragment = gql`
  ${ProductDescriptionFragment}
  fragment OnBoarding on OnBoarding {
    createdAt
    id
    kitchenRecommendations {
      ...ProductDescription
    }
    usage
    kitchenSizeGroup
    kitchenStyleGroup
    kitchenTypeGroup
    moodboardImages
    textures {
      ...ProductDescription
    }
    url
    usageDescription
    usageImage
    usageProduct {
      ...ProductDescription
    }
    wishlistProducts {
      ...ProductDescription
    }
  }
`
